import { useEffect, useState } from 'react';
import { useLocalTranslation } from '@/hooks/useLocalTranslation';
import RoundBlueButton from '@/components/profile/roundBlueButton'
import { listOfSections } from "@/pages/profile/sections/bssDetails/constants"
import ImageHandler from '@/components/common/imageHandler/imageHandler'
import ImageEditer from '@/components/common/imageHandler/imageEditer'
import UploadImage from "@/assets/icons/upload.png"
import '@/pages/profile/sections/common.css'

export default function PanCard(props: any) {
    const { common, profile } = useLocalTranslation();
    const [openFilePopup, setOpenFilePopup] = useState(false)
    const [image, setImage] = useState("")

    useEffect(() => {
        if (props.value) {
            setImage(props.value)
        }
    }, [props.value])


    const initFilePopup = () => {
        setOpenFilePopup(true)
        setTimeout(() => {
            setOpenFilePopup(false)
        }, 100)
    }

    const imageSelected = (imageDataURI: any) => {
        setImage(imageDataURI)
        setImgToParentCom(imageDataURI)
    }

    const setImgToParentCom = (imageDataURI: any) => {
        const eventObj = {
            target: {
                value: imageDataURI
            }
        }
        props.handleInputChange(eventObj, listOfSections.panCard)
    }

    return (
        <div className='profileSectionOfSectionCommonMainCon'>
            <div className='commonCon1'>
                <ul className='list-disc list-inside'>
                    {profile.bssSection.notes.n1.map((n: string, index: number) => (
                        <li key={index}>{n}</li>
                    ))}
                </ul>
            </div>

            <p className='commonH5'>
                {profile.bssSection.notes.n2}
            </p>

            <p className='commonH6'>
                {profile.bssSection.notes.n3}
            </p>

            <p className='commonH5'>
                {profile.fields.panCard}
                <span className='text-[#FF2828]'>*</span>
            </p>

            <p className='commonH7'>
                {profile.placeHolders.panCard}
            </p>

            {props.errMsg !== "" &&
                <p className='commonErr1'>{props.errMsg}</p>
            }

            {image ? (
                <div className='proofImgCon'>
                    <ImageEditer
                        initFilePopup={initFilePopup}
                        ogImage={image}
                        setImgToParentCom={setImgToParentCom}
                    // height={200}
                    // width={330}
                    />
                </div>
            ) : (
                <div className='imagePlaceholder'>
                    <img
                        className='w-[42px]'
                        src={UploadImage} alt='UploadImage' />
                    <p className='p1'>{common.statusText.tapOrClickHereToUploadYourDocument}</p>
                    <button
                        onClick={initFilePopup}
                        className='b1'>
                        {common.statusText.browseFiles}
                    </button>
                </div>
            )}

            <ImageHandler
                openFilePopup={openFilePopup}
                imageSelected={imageSelected}
            />

            <div className='commonBtnCon1'>
                <RoundBlueButton
                    disabled={props.isSubmitBtnLoading}
                    onClick={() => props.handleSubmit(listOfSections.panCard)}
                />
            </div>
        </div>
    );
}
